// Ruoli e permessi lato UI — specchio di backend/auth.py (il backend resta l'autorità).
export const RUOLI = ['admin', 'operatore', 'social_manager', 'videomaker', 'direttore', 'agente'];

export const RUOLO_LABEL = {
  admin: 'Admin', operatore: 'Operatore', social_manager: 'Social media manager',
  videomaker: 'Videomaker', direttore: 'Direttore', agente: 'Agente', boss: 'Boss',
};

export const RUOLI_SOCIAL = ['admin', 'boss', 'social_manager'];     // programma, approva, portale, report
export const RUOLI_ANALYTICS = ['admin', 'boss', 'social_manager'];
export const RUOLI_WORKLOAD = ['admin', 'boss', 'social_manager'];
export const RUOLI_OPERATIVI = ['operatore', 'social_manager', 'videomaker'];

export const can = (user, ruoli) => !!user && ruoli.includes(user.ruolo);
export const ruoloLabel = (r) => RUOLO_LABEL[r] || r || '';
